// extracted by mini-css-extract-plugin
module.exports = {"ratingLayout":"Rt","ratingLabel":"St"};